import React from 'react';
import {Drawer, Stack, Tooltip} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";

import Box from "@mui/material/Box";

import {   useCSVReader } from 'react-papaparse';

import {changeUploadFile} from "./uploadFileSlice";
import {uploadSubscriber} from "../../ExternalData/Subscriber/SubscriberClient";

import {uploadExchange} from "../../ExternalData/Exchange/ExchangeClient";
import {uploadUsage} from "../../ExternalData/Usage/UsageClient";
import {uploadViewership} from "../../ExternalData/Viewership/ViewershipClient";
import {uploadProfile} from "../../ExternalData/Profile/ProfileClient";
import {uploadProduct} from "../../ExternalData/Product/ProductClient";
import {uploadPlatform} from "../../ExternalData/Platform/PlatformClient";
import {uploadLicense} from "../../ExternalData/License/LicenseClient";
import {uploadFinancial} from "../../ExternalData/Financial/FinancialClient";
import Button from "@mui/material/Button";
import {changeFinancial} from "../../ExternalData/Financial/financialSlice";
import {changeStakeholderList} from "../../ExternalData/StakeholderList/stakeholderListSlice";
import {changeLicense} from "../../ExternalData/License/licenseSlice";
import {changePlatform} from "../../ExternalData/Platform/platformSlice";
import {changeProduct} from "../../ExternalData/Product/productSlice";
import {changeProfile} from "../../ExternalData/Profile/profileSlice";
import {changeSubscriber} from "../../ExternalData/Subscriber/subscriberSlice";
import {changeUsage} from "../../ExternalData/Usage/usageSlice";
import {changeViewership} from "../../ExternalData/Viewership/viewershipSlice";
import {changeInterest} from "../../ExternalData/Interest/interestSlice";
import {uploadInterest} from "../../ExternalData/Interest/InterestClient";
import {uploadStakeholderList} from "../../ExternalData/StakeholderList/StakeholderListClient";
import {changeCrudSnackbar} from "../crudSnackbarSlice";
import CrudSnackbar from "../CrudSnackbar";
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from "@mui/material/IconButton";
import DateRangeIcon from "@mui/icons-material/DateRange";

export default function  UploadFileDrawer ()  {

    const [papaData, setPapaData] = React.useState(null);
    const { CSVReader } = useCSVReader();
    const selectorUploadFileDrawerState = useSelector((state) => state.uploadFileSlc.value.uploadFileDrawerState);
    const selectorUploadFileDrawerMode = useSelector((state) => state.uploadFileSlc.value.uploadFileDrawerMode);
    const [uploadFileName, setUploadFileName] = React.useState(null);


    const dispatchData = useDispatch();

    const handleDownloadTemplate = () => {
console.log("download template triggered");
console.log("selectorUploadFileDrawerMode: ", selectorUploadFileDrawerMode);
        let templateFile = '';

        switch(selectorUploadFileDrawerMode) {

            case 'Exchange':
                templateFile = '/templates/exchange_template.csv';
                break;

            case 'Financial':
                templateFile = '/templates/financial_template.csv';
                break;

            case 'Interest':
                templateFile = '/templates/interest_template.csv';
                break;

            case 'License':
                templateFile = '/templates/license_template.csv';
                break;

            case 'Platform':
                templateFile = '/templates/platform_template.csv';
                break;

            case 'Product':
                templateFile = '/templates/product_template.csv';
                break;

            case 'Profile':
                templateFile = '/templates/profile_template.csv';
                break;

            case 'Subscriber':
                templateFile = '/templates/subscriber_template.csv';
                break;

            case 'Usage':
                templateFile = '/templates/usage_template.csv';
                break;

            case 'Viewership':
                templateFile = '/templates/viewership_template.csv';
                break;

            case 'Stakeholder List':
                templateFile = '/templates/stakeholder_list_template.csv';
                break;

            default:
                return;
        }

        const link = document.createElement('a');
        link.href = templateFile;
        link.download = templateFile.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // window.open(templateFile, '_blank');
    };

    function closeUploadFileForm() {
        dispatchData(changeUploadFile({uploadFileDrawerState: false }));
    };

    // function handleSubmit(){
    //
    //     if(selectorUploadFileDrawerMode === "Exchange"){
    //         try {
    //             uploadExchange(papaData.data)
    //                 .then(closeUploadFileForm)
    //                 .then(        dispatchData(changeStakeholderList({exchangeGridRefresh: true})))} catch(error) {
    //             console.log(error)
    //         }}
    //     if(selectorUploadFileDrawerMode === "Financial"){
    //         try {
    //             uploadFinancial(papaData.data)
    //     .then(closeUploadFileForm)
    //             .then(        dispatchData(changeFinancial({financialGridRefresh: true})))} catch(error) {
    //         console.log(error)
    //     }}
    //     if(selectorUploadFileDrawerMode === "Interest"){
    //         try {
    //             uploadInterest(papaData.data)
    //                 .then(closeUploadFileForm)
    //                 .then(        dispatchData(changeInterest({interestGridRefresh: true})))} catch(error) {
    //             console.log(error)
    //         }}
    //     if(selectorUploadFileDrawerMode === "License"){
    //         try {
    //             uploadLicense(papaData.data)
    //                 .then(closeUploadFileForm)
    //                 .then(        dispatchData(changeLicense({licenseGridRefresh: true})))} catch(error) {
    //             console.log(error)
    //         }}
    //     if(selectorUploadFileDrawerMode === "Platform"){
    //         try {
    //             uploadPlatform(papaData.data)
    //                 .then(closeUploadFileForm)
    //                 .then(        dispatchData(changePlatform({platformGridRefresh: true})))} catch(error) {
    //             console.log(error)
    //         }}
    //     if(selectorUploadFileDrawerMode === "Product"){
    //         try {
    //             uploadProduct(papaData.data)
    //                 .then(closeUploadFileForm)
    //                 .then(        dispatchData(changeProduct({productGridRefresh: true})))} catch(error) {
    //             console.log(error)
    //         }}
    //     if(selectorUploadFileDrawerMode === "Profile"){
    //         try {
    //             uploadProfile(papaData.data)
    //                 .then(closeUploadFileForm)
    //                 .then(        dispatchData(changeProfile({profileGridRefresh: true})))} catch(error) {
    //             console.log(error)
    //         }}
    //     if(selectorUploadFileDrawerMode === "Stakeholder List"){
    //         try {
    //             uploadStakeholderList(papaData.data)
    //                 .then(closeUploadFileForm)
    //                 .then(        dispatchData(changeStakeholderList({stakeholderListGridRefresh: true})))} catch(error) {
    //             console.log(error)
    //         }}
    //     if(selectorUploadFileDrawerMode === "Subscriber"){
    //     try {
    //         uploadSubscriber(papaData.data)
    //             .then(closeUploadFileForm)
    //             .then(        dispatchData(changeSubscriber({subscriberGridRefresh: true})))} catch(error) {
    //         console.log(error)
    //     }}
    //     if(selectorUploadFileDrawerMode === "Usage"){
    //         try {
    //             uploadUsage(papaData.data)
    //                 .then(closeUploadFileForm)
    //                 .then(        dispatchData(changeUsage({usageGridRefresh: true})))} catch(error) {
    //             console.log(error)
    //         }}
    //     if(selectorUploadFileDrawerMode === "Viewership"){
    //         try {
    //             uploadViewership(papaData.data)
    //                 .then(closeUploadFileForm)
    //                 .then(        dispatchData(changeViewership({viewershipGridRefresh: true})))} catch(error) {
    //             console.log(error)
    //         }}
    // };


    const convertDate = (dateString) => {

        if(!dateString) return null;

        const parts = dateString.split('/');

        if(parts.length !== 3) return dateString;

        const [month, day, year] = parts;

        return `${year}-${month.padStart(2,'0')}-${day.padStart(2,'0')}`;
    };


    const transformedData = papaData?.data?.map(row => ({

        ...row,

        rate_date: convertDate(row.rate_date),

        effective_date: convertDate(row.effective_date),

        expired_on: convertDate(row.expired_on),

        period_end_date: convertDate(row.period_end_date),

        adjust_from: convertDate(row.adjust_from),

        adjust_to: convertDate(row.adjust_to),

        avail_begin: convertDate(row.avail_begin),

        avail_end: convertDate(row.avail_end),

        execution_date: convertDate(row.execution_date),

        photo_start_date: convertDate(row.photo_start_date),

        date_of_birth: convertDate(row.date_of_birth),

        date_of_death: convertDate(row.date_of_death),

        date_of_dissolution: convertDate(row.date_of_dissolution),

        contract_date: convertDate(row.contract_date),

        work_begin_date: convertDate(row.work_begin_date),

        count_date: convertDate(row.count_date),

        view_date: convertDate(row.view_date)

    }));


    function handleSubmit() {

        let uploadPromise;
        let refreshAction;

        switch(selectorUploadFileDrawerMode) {

            case "Exchange":
                uploadPromise = uploadExchange(transformedData);
                refreshAction = changeStakeholderList({exchangeGridRefresh: true});
                break;

            case "Financial":
                uploadPromise = uploadFinancial(transformedData);
                refreshAction = changeFinancial({financialGridRefresh: true});
                break;

            case "Interest":
                uploadPromise = uploadInterest(transformedData);
                refreshAction = changeInterest({interestGridRefresh: true});
                break;

            case "License":
                uploadPromise = uploadLicense(transformedData);
                refreshAction = changeLicense({licenseGridRefresh: true});
                break;

            case "Platform":
                uploadPromise = uploadPlatform(transformedData);
                refreshAction = changePlatform({platformGridRefresh: true});
                break;

            case "Product":
                uploadPromise = uploadProduct(transformedData);
                refreshAction = changeProduct({productGridRefresh: true});
                break;

            case "Profile":
                uploadPromise = uploadProfile(transformedData);
                refreshAction = changeProfile({profileGridRefresh: true});
                break;

            case "Stakeholder List":
                uploadPromise = uploadStakeholderList(transformedData);
                refreshAction = changeStakeholderList({stakeholderListGridRefresh: true});
                break;

            case "Subscriber":
                uploadPromise = uploadSubscriber(transformedData);
                refreshAction = changeSubscriber({subscriberGridRefresh: true});
                break;

            case "Usage":
                uploadPromise = uploadUsage(transformedData);
                refreshAction = changeUsage({usageGridRefresh: true});
                break;

            case "Viewership":
                uploadPromise = uploadViewership(transformedData);
                refreshAction = changeViewership({viewershipGridRefresh: true});
                break;

            default:
                return;
        }

        uploadPromise

            .then(() => {

                closeUploadFileForm();

                dispatchData(refreshAction);

                dispatchData(
                    changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "success",
                        crudMessage: "Upload successful"
                    })
                );
            })

            .catch((error) => {

                console.log(error);

                dispatchData(
                    changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "error",
                        crudMessage: "Upload failed"
                    })
                );
            })

            .finally(() => {

                console.log("Upload process completed");

            });
    }

    return (
        <Drawer
            anchor='top'
            open={selectorUploadFileDrawerState}
            onClose={closeUploadFileForm}
        >
            <Box
                sx={{ width: 800 , height: 200, pl: 5}}
                role="presentation"
            >
                <br/>
                <Stack direction={"horizontal"}
                       alignItems={"center"}
                       spacing={5}>
                    <h2 style={ { margin: 0, paddingLeft: 0,
                        cursor:'pointer'}} onClick={() => closeUploadFileForm()}>Upload {selectorUploadFileDrawerMode} File</h2>
                <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Download Template"}>
                    <IconButton onClick={() => handleDownloadTemplate()}
                        // sx={{pt: 0}}
                                sx={{
                                    p: 2,                 // remove default padding
                                    // display: 'flex',
                                    // alignItems: 'bottom', // vertical bottom
                                    // justifyContent: 'center',
                                    // height: '100%',       // important if parent has height
                                }}
                    >
                        <DownloadIcon color="primary"  variant="standard"  />
                    </IconButton>
                </Tooltip>
                </Stack>
                {/*    <input type="file" accept=".csv" onChange={handleFileSelect}/>*/}
                {/*    <input type="submit" value="Upload File" />*/}
                {/*</form>*/}
                <br/>
                <br/>
                <Stack direction={"horizontal"}>
                {/*<CSVReader*/}

                {/*    config={{header: true, skipEmptyLines: true,dynamicTyping: true,}}*/}
                {/*           onUploadAccepted={(results*/}
                {/*           ) => {*/}
                {/*               setPapaData (results);*/}
                {/*               console.log("papa data");*/}
                {/*               console.log(results);*/}
                {/*               console.log("file name");*/}
                {/*               console.log(results.header);*/}
                {/*           }*/}
                {/*           }*/}
                {/*           noDrag>*/}

                {/*    {*/}
                {/*        (*/}
                {/*            {*/}
                {/*                getRootProps,*/}
                {/*                acceptedFile,*/}
                {/*            }) => (*/}
                {/*            <>*/}
                {/*                <div {...getRootProps()}>*/}
                {/*                    <Button sx={{ width: 180 ,  pl: 5}}>Select CSV File</Button>*/}
                {/*                </div>*/}
                {/*            </>*/}
                {/*        )}*/}
                {/*</CSVReader>*/}

                    {/*<CSVReader*/}
                    {/*    config={{ header: true, skipEmptyLines: true, dynamicTyping: true }}*/}
                    {/*    onUploadAccepted={(results) => {*/}
                    {/*        setPapaData(results);*/}
                    {/*        setUploadFileName( results && results.meta && results.meta.name ? results.meta.name : null);  // ✅ Set the file name*/}
                    {/*        console.log("papa data", results);*/}
                    {/*        console.log("file name", results && results.meta ? results.meta.name : "N/A");*/}
                    {/*    }}*/}
                    {/*    noDrag*/}
                    {/*>*/}
                    {/*    {({ getRootProps, acceptedFile }) => (*/}
                    {/*        <>*/}
                    {/*            <div {...getRootProps()}>*/}
                    {/*                <Button sx={{ width: 180, pl: 5 }}>Select CSV File</Button>*/}
                    {/*            </div>*/}
                    {/*        </>*/}
                    {/*    )}*/}
                    {/*</CSVReader>*/}
                    <CSVReader
                        config={{ header: true, skipEmptyLines: true, dynamicTyping: true }}
                        onUploadAccepted={(results, file) => {
                            setPapaData(results);
                            console.log("papa data in csv reader");
                            console.log(results.data);
                            console.log("selectorUploadFileDrawerMode: ", selectorUploadFileDrawerMode);
                            // Do NOT try to use results.meta.name — use acceptedFile instead
                        }}
                        noDrag
                    >
                        {({ getRootProps, acceptedFile }) => (
                            <>
                                <div {...getRootProps()}>
                                    <Button sx={{ width: 180, pl: 5 }}>Select CSV File</Button>
                                </div>
                                {acceptedFile && (
                                    <Box sx={{ width: 200, pl: 5 }}>
                                        <p>{acceptedFile.name}</p> {/* ✅ Show actual file name */}
                                    </Box>
                                )}
                            </>
                        )}
                    </CSVReader>
                    <Box                 sx={{ width: 200 ,  pl: 5}}>
                        <p>{uploadFileName}</p></Box>

                <Button onClick={() => (handleSubmit())} >Upload</Button>
                {/*    <Button onClick={handleDownloadTemplate}>*/}
                {/*        Download Template*/}
                {/*    </Button>*/}
                </Stack>
            </Box>
            <CrudSnackbar/>
        </Drawer>
    )

};

